<template>
  <div>
    <shop-start
      v-if="currentComponent === 'shop-start'"
      v-on:open-form="openForm"
      :temp-email="tempEmail"      
      :user="user"
      :stores="stores"/>
    <home-start
      v-if="currentComponent === 'home-start'"
      v-on:guest-start="guestStart"
      v-on:to-log="toLog"
      :user="user"/>
    <shop-form
      v-if="currentComponent === 'shop-form'"
      v-on:to-homepage="toHomepage"
      :temp-email="tempEmail"
      :temp-store="tempStore"
      :selected-yunda-store="tempStore"/>
    <log-and-sign
      v-if="currentComponent === 'log-and-sign'"
      v-on:start-over="startOver"
      v-on:success-login="logIn"
      :email="tempEmail"
      :user="user"/>
    <dashboard
      v-if="currentComponent === 'dashboard'"
      v-on:log-out="toLog"
      :user="user"
      :stores="stores"/>
  </div>
</template>

<script>
import ShopStart from '@/components/ShopStart'
import ShopForm from '@/components/ShopForm'
import HomeStart from '@/components/HomeStart'
import LogAndSign from '@/components/LogAndSign'
import Dashboard from '@/components/Dashboard'
import { db } from '@/main'

const shopMode = true

export default {
  name: 'Shipping',
  props: ['user'],
  data () {
    return {
      currentComponent: shopMode ? 'shop-start' : 'home-start',
      tempEmail: '',
      tempStore: null,
      isLogged: (this.user === null),
      stores: null
    }
  },
  mounted: function () {
    let storeInfoRef = db.collection('store').orderBy('mapIndex')
    this.$bind('stores', storeInfoRef)
  },
  watch: {
    user: function () {
      let isLogged = false
      if (this.user !== null) {
        isLogged = true
        if (this.currentComponent === 'home-start') {
          this.currentComponent = 'dashboard'
        }
      }
      this.isLogged = isLogged
    }
  },
  methods: {
    openForm: function (dataFromShopStart) {
      this.tempEmail = dataFromShopStart.email
      this.tempStore = dataFromShopStart.store
      this.currentComponent = 'shop-form'
    },
    toHomepage: function () {
      this.currentComponent = shopMode ? 'shop-start' : 'home-start'
    },
    startOver: function () {
      this.currentComponent = 'home-start'
    },
    guestStart: function (EmailInput) {
      this.tempEmail = EmailInput
      this.currentComponent = 'shop-start'
    },
    toLog: function (EmailInput) {
      this.tempEmail = EmailInput
      this.currentComponent = 'log-and-sign'
    },
    logIn: function () {
      this.tempEmail = ''
      this.currentComponent = 'dashboard'
    }
  },
  components: {
    ShopStart, ShopForm, HomeStart, LogAndSign, Dashboard
  }
}
</script>

<style>

</style>
